import React from 'react'
import './Biodata.scss'
function Bioheader() {
  return (
    <div class="bg-white p-3 mt-4 mb-4 rounded-lg shadow-sm top_bio_heading">
      <h1>Craft a Free Stunning Marriage Biodata, Loved by Everyone, in 8 Languages</h1>
      <p>Create, Select, and Download Your Biodata in Just 5 Minutes, Anywhere Anytime.</p>
  </div>
  )
}

export default Bioheader
